import { X } from "lucide-react";
import { Spinner } from "reactstrap";
import FormField from "../ui/FormField";
import { Button } from "../Button";
import { useEffect, useState } from "react";

const MeetingAdd = ({
  workflowId,
  setShowCreateTask,
  formData, 
  setFormData,
  handleSubmit,
  isLoader,
  clients,
  workflowTemplates,
  accountId,
  type
}) => {
const [errors, setErrors] = useState({});
  const handleFieldChange = (name) => (val) =>
    setFormData((prev) => ({ ...prev, [name]: val }));

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

 const getNowDateTime = () => {
  const now = new Date();
  const tzOffset = now.getTimezoneOffset() * 60000;
  const localISOTime = new Date(now - tzOffset)
    .toISOString()
    .slice(0, 16);
  return localISOTime;
};

const getNowPlus30Min = () => {
  const now = new Date();
  now.setMinutes(now.getMinutes() + 30);

  const tzOffset = now.getTimezoneOffset() * 60000;
  return new Date(now - tzOffset).toISOString().slice(0, 16);
};


useEffect(() => {
  if (!workflowId) {
    setFormData((prev) => ({
      ...prev,
      noticeIssueDate: getNowPlus30Min(),
    }));
  }
}, [workflowId]);


const validateForm = () => {
  const newErrors = {};

  if (!formData.meetingType)
    newErrors.meetingType = "Meeting Type is required";

  if (!formData.meetingDate)
    newErrors.meetingDate = "Meeting Date is required";

  if (!formData.presentMembers)
    newErrors.presentMembers = "Present Members is required";

  if (!formData.noticeIssueDate)
    newErrors.noticeIssueDate = "Notice Issue Date is required";

  if (!formData.agenda)
    newErrors.agenda = "Agenda is required";

  // date rules
  if (
    formData.noticeIssueDate &&
    new Date(formData.noticeIssueDate) < new Date()
  ) {
    newErrors.noticeIssueDate =
      "Notice Issue Date cannot be in the past";
  }

  if (
    formData.noticeIssueDate &&
    formData.meetingDate &&
    new Date(formData.meetingDate) <=
      new Date(formData.noticeIssueDate)
  ) {
    newErrors.meetingDate =
      "Meeting Date must be greater than Notice Issue Date";
  }

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};


const onSubmit = () => {
  if (!validateForm()) return;
  handleSubmit();
};


  const clearFormData = ()=> {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);
    setFormData({
        meetingType: "",
        meetingDate: "",
        presentMembers: "",
        noticeIssueDate: getNowPlus30Min(),
        agenda: "",
    });
  }

  return (
    <div onClick={(e)=> e.stopPropagation()} className="bg-white rounded-lg shadow-xl max-w-3xl w-full p-3 overflow-y-auto">
      <div className="flex flex-row items-center justify-between">
        <h1 className="text-2xl font-semibold text-gray-800">
          {workflowId ? "Edit Meeting" : "Create Meeting"}
        </h1>
        <button
            onClick={() => {setShowCreateTask(workflowId ? null : false); clearFormData();}}
            aria-label="Close"
            type="button"
            className="p-1 rounded-md bg-red-50 hover:bg-red-100 text-red-600 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-400"
        >
            <X size={20} />
        </button>
      </div>

      <div>
        <div className="grid md:grid-cols-2 sm:grid-cols-2 gap-2">
          <FormField
            label="Meeting Type"
            type="dropdown"
            required
            value={formData.meetingType}
            onChange={handleFieldChange("meetingType")}
             error={errors.meetingType}
            options={[
                "BOARD_MEETING",
                "GENERAL_MEETING",
                // "COMMITTEE_MEETING",
            ]}
            
          />
           <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Notice Issue Date <span className="text-red-500">*</span>
                </label>
               <input
  type="datetime-local"
  value={formData.noticeIssueDate}
  min={getNowPlus30Min()}
  onChange={(e) =>
    handleChange("noticeIssueDate", e.target.value)
  }
  onKeyDown={(e) => e.preventDefault()}
  className="w-full px-2 py-1 border rounded-md"
/>
{errors.noticeIssueDate && (
  <p className="text-xs text-red-500 mt-1">
    {errors.noticeIssueDate}
  </p>
)}

                </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
                Meeting Date <span className="text-red-500">*</span>
            </label>
            <input
  type="datetime-local"
  value={formData.meetingDate}
  min={formData.noticeIssueDate}
  onChange={(e) =>
    handleChange("meetingDate", e.target.value)
  }
  onKeyDown={(e) => e.preventDefault()}
  className="w-full px-2 py-1 border rounded-md"
  
/>
{errors.meetingDate && (
  <p className="text-xs text-red-500 mt-1">
    {errors.meetingDate}
  </p>
)}


            </div>
            <FormField
              label="Present Members"
              type="text"
              required
              maxLength={100}
              value={formData.presentMembers}
              onChange={handleFieldChange("presentMembers")}
              error={errors.presentMembers}
            />
            
           
          
        </div>

        <div className="mt-1">
          <FormField
            label="Agenda"
            type="description"
            rows="2"
            required
            value={formData.agenda}
            onChange={handleFieldChange("agenda")}
            error={errors.agenda}
          />
        </div>
      </div>
      <div className="flex flex-row items-center justify-end gap-2">
        <button
            type="button"
            onClick={() => {setShowCreateTask(workflowId ? null : false); clearFormData();}} 
            className="bg-red-50 py-2 px-4 border border-red-300 rounded-md text-sm font-medium text-red-700 hover:bg-red-100"
        >
            Cancel
        </button>
        {isLoader ? 
        <Button label={<Spinner size={"sm"}/>}/> :
        <Button label={`${workflowId ? "Update" : "Save"}`} onClick={onSubmit} />}
      </div>
    </div>
  );
};

export default MeetingAdd;
